import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import DataContainer from 'Components/UI/DataContainer';
import GoalSubsectionFieldlist from 'Components/Universal/Questionnaire/Sections/GoalSubsectionFieldlist';
import {
  goalResourcesToRecords,
} from 'Helpers/Goals';

const styles = {
  root: {
    flex: 1,
  },
};

const GoalsView = ({
  classes,
  className,
  goalCollection,
  householdId,
  addGoal,
  saveGoalToCollection,
  removeGoalFromCollection,
  goalResources,
}) => {
  const loading = goalCollection === null;

  return (
    <div className={classNames(classes.root, className)}>
      <DataContainer
        loading={loading}
        component={GoalSubsectionFieldlist}
        componentProps={{
          householdId: Number(householdId),
          planPrompt: 'View Plan',
          disableAddButton: loading,
          loadedGoals: goalResourcesToRecords(goalResources),
          saveGoal: saveGoalToCollection,
          removeGoal: removeGoalFromCollection,
          addGoal,
        }}
      />
    </div>
  );
};

GoalsView.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  goalCollection: PropTypes.object.isRequired,
  householdId: PropTypes.number.isRequired,
  addGoal: PropTypes.func.isRequired,
  saveGoalToCollection: PropTypes.func.isRequired,
  removeGoalFromCollection: PropTypes.func.isRequired,
  goalResources: PropTypes.array.isRequired,
};

GoalsView.defaultProps = {
  className: '',
};

export default withStyles(styles)(GoalsView);
